let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hS8JC")).then(() => parcelRequire('1G0hy'));